import React, { useState } from 'react'
import ColorPickerV2 from 'src/components/common/ColorPickerV2'
import { useCartContext } from 'src/lib/contexts/CartContext'
import { PROGRESS_BAR_TYPE } from '@shopflo/ui'
import FloCheckbox from 'src/components/common/form-elements/FloCheckbox'
import { Input } from '@shopflo/ui'
import ToggleButton from 'src/components/common/buttons/ToggleButton'

export const MilestoneControl = () => {
  const {
    getters: { customizations },
    actions: { setCustomizations }
  } = useCartContext()

  const [successMessage, setSuccessMessage] = useState(customizations.completedMessage || '')

  const handleCustomizationChange = (updates: Record<string, any>) => {
    setCustomizations({
      ...customizations,
      ...updates
    })
  }

  return (
    <div className='flex flex-col gap-5'>
      <div className='flex flex-col gap-2 pb-5 border-b border-zinc-950/6'>
        <div className='flex gap-2 w-full'>
          <ToggleButton
            isActive={customizations.type === PROGRESS_BAR_TYPE.STATIC}
            onClick={() => handleCustomizationChange({ type: PROGRESS_BAR_TYPE.STATIC })}
            iconName='static_milestone'
            label='Static'
          />
          <ToggleButton
            isActive={customizations.type === PROGRESS_BAR_TYPE.DYNAMIC}
            onClick={() => handleCustomizationChange({ type: PROGRESS_BAR_TYPE.DYNAMIC })}
            iconName='dynamic_milestone'
            label='Dynamic'
          />
        </div>
        <p className='text-text-xs-medium text-zinc-500'>Display every offer and its required cart value.</p>
      </div>

      {/* Color Pickers Section */}
      <div className='flex flex-col gap-3'>
        <div className='grid w-full gap-2 grid-cols-2'>
          <ColorPickerV2
            label='Background'
            color={customizations.backgroundColor || customizations.filledColor}
            onChange={color => handleCustomizationChange({ backgroundColor: color })}
          />
          <ColorPickerV2
            label='Primary'
            color={customizations.filledColor}
            onChange={color => handleCustomizationChange({ filledColor: color })}
          />
          <ColorPickerV2
            label='Header text'
            color={customizations.textonProgressBar_headerColor}
            onChange={color => handleCustomizationChange({ textonProgressBar_headerColor: color })}
            showVisibilityToggle={true}
            isVisible={customizations.textonProgressBar_header}
            onVisibilityChange={visible => handleCustomizationChange({ textonProgressBar_header: visible })}
          />
        </div>
      </div>

      <div className='flex flex-col gap-3 pb-5 border-b border-zinc-950/6'>
        <p className='text-text-xs-medium text-zinc-950/48'>Milestone Badge</p>
        <div className='grid grid-cols-2 gap-2'>
          <ColorPickerV2
            label='Cart Value'
            color={customizations.textonProgressBar_amountColor}
            onChange={color => handleCustomizationChange({ textonProgressBar_amountColor: color })}
          />
          <ColorPickerV2
            label='Subtext'
            color={customizations.textonProgressBar_titleColor}
            onChange={color => handleCustomizationChange({ textonProgressBar_titleColor: color })}
            showVisibilityToggle={true}
            isVisible={customizations.textonProgressBar_title}
            onVisibilityChange={visible => handleCustomizationChange({ textonProgressBar_title: visible })}
          />
        </div>
      </div>

      <div className='flex flex-col gap-4'>
        <div className='flex items-center justify-between gap-3'>
          <div className='flex flex-col justify-center flex-1'>
            <p className='text-text-sm-medium text-zinc-600'>Success Message</p>
            <p className='text-text-xs-medium text-zinc-500'>Show custom message after completing all milestone</p>
          </div>
          <FloCheckbox
            type='SWITCH'
            value={customizations.completedMessage_enabled}
            setValue={(value: boolean) => {
              handleCustomizationChange({ completedMessage_enabled: value })
            }}
          />
        </div>
        {customizations.completedMessage_enabled && (
          <div className='flex flex-col gap-1'>
            <Input
              label='Message'
              maxSize={60}
              dimension='md'
              variant='outline'
              value={successMessage}
              onChange={e => {
                setSuccessMessage(e.target.value)
                handleCustomizationChange({ completedMessage: e.target.value })
              }}
              placeholder=''
              className='w-full'
            />
          </div>
        )}
      </div>
    </div>
  )
}
